module.exports = __webpack_public_path__ + "img/logo_centum.feb8f35f.png";